import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/itemcard.module.scss'

import { getImageUrl } from '../util/images'
import CustomMarkdown from 'sites/auctions/components/CustomMarkdown'
import FavoriteItem from './FavoriteItem'
import { getItemUserStatus } from '../components/utils'
import FixedItemBidInfo from './FixedItemBidInfo'
import FixedItemAmountSelector from './FixedItemAmountSelector'
import FixedItemPurchaseButton from './FixedItemPurchaseButton'
import { calculatePurchaseAmount } from './utils'
import { navigateFromAuctionToItem } from '../util/auctionScrollRestore'

export default function FixedItemCard({item, auction, auctionState, currentUserId, isCheckedIn, 
  setShowFixedItemModal,setPurchaseItem, setPurchaseQuantity, purchaseResponse
 }) {

  const [amount, setAmount] = useState(1)
  const [imageUrl, setImageUrl] = useState()

  const fixedItemRoute = {
    pathname: '/auction/fixeditem',
    search: `?auctionId=${auction.AuctionCode}&fixedItemId=${item.ItemCode}`,
  }

  const handleFixedItemNavigation = (event) => {
    navigateFromAuctionToItem(event, fixedItemRoute, auction.AuctionCode)
  }

  const linkObj = {
    itemCode: item.ItemCode,
    auctionCode: auction.AuctionCode,
    link: 'fixedItemPage',
    onClick: handleFixedItemNavigation,
  }

  //use effect to calculate how many user is allowed to purchase
  useEffect(() => {
    const nextAmount = calculatePurchaseAmount(amount, item)
    if (nextAmount !== amount) setAmount(nextAmount)

  }, [amount, item])

  useEffect(() => {
    // confirm what item number was just purchased
    const purchasedItem = purchaseResponse?.FixedItemId
    //reset amount to 1 for only that item
    if (purchasedItem === item.FixedItemId && amount !== 1) setAmount(1)

  }, [purchaseResponse, amount])

  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, item?.ItemCode, item?.ImageFilename)
    setImageUrl(url)
  }, [auction, item])

  if (auctionState === 'ended' && item.MyAmountPurchased === 0) return <></> 

  const outlineClass = () => {
    const result = getItemUserStatus(auction, item, currentUserId)
    if (result) return themeCss[`outline-${result}`]
    else return ''
  }

  return (
    <div className={`${css['card-container']} ${themeCss['shadowed']} ${outlineClass()}`}>

      <Link className={css['card-image']} to={fixedItemRoute} onClick={handleFixedItemNavigation}>
        <img src={imageUrl} alt={`${item.Title}`} />
      </Link>

      <Link className={`${css['card-title']} ${themeCss['bold-nodecoration']}`} to={fixedItemRoute} onClick={handleFixedItemNavigation}>

        {/* causes problems with alphabetization */}
        {/*<CustomMarkdown text={item.Title} noLineBreaks={true} cssClass={`${css['card-title']} ${themeCss['truncate-twoline']}`} />*/}
        <span className={`${themeCss['truncate-twoline']}`}>
          {item.Title}
        </span>
      </Link>

      {auctionState !== 'before' && <FixedItemBidInfo auctionState={auctionState} item={item} 
        auction={auction} currentUserId={currentUserId} /> }

      <FavoriteItem auctionId={auction.AuctionId} itemId={item.FixedItemId}/>

      {(auctionState === 'started' && isCheckedIn) && (
        <>
          <div className={`${css['bid-selector-container']}`} >
            <FixedItemAmountSelector item={item} amount={amount} setAmount={setAmount} />
          </div>
          <FixedItemPurchaseButton amount={amount} setShowFixedItemModal={setShowFixedItemModal} 
            setPurchaseQuantity={setPurchaseQuantity} setPurchaseItem={setPurchaseItem} item={item} />
        </>
        )}
      {(auctionState === 'started' && !isCheckedIn) && (
        <button className={`${themeCss['button']} ${themeCss['FilledYellow']} ${css['place-bid-button']}`}
          disabled={true}>
        Check In to Make Purchase</button>)}

        <Link className={css['item-description-link']} to={fixedItemRoute} onClick={handleFixedItemNavigation}>
          <CustomMarkdown text={item.Description} noLineBreaks={true} cssClass={`${css['card-description']} ${themeCss['truncate-fourline']}`} linkObj={linkObj} />
        </Link>
    </div>
  )
}
